import axiosInstance from "../../../Utils/axios";
import axios from "axios";
let cancelToken;

//obtaining the paginated data
export const getDyeHouse = (postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/production/dye-house?offset=0&limit=${postsPerPage}&ordering=-id`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllDyeHouse = () => axiosInstance.get(`api/v1/production/dye-house?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDyeHouse = (number, postsPerPage) =>
  axiosInstance.get(
    `api/v1/production/dye-house?offset=${(number - 1) * postsPerPage}&limit=${postsPerPage}&ordering=-id`
  );

//creating function
export const createDyeHouse = (body) => axiosInstance.post(`api/v1/production/dye-house`, body);
//updating function
export const updateDyeHouse = (id, body) => axiosInstance.patch(`api/v1/production/dye-house/${id}`, body);

//searching function
export const handleSearch = (search, postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/production/dye-house?offset=0&limit=${postsPerPage}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};

// checking the redundant data
export const checkRedundantDataDyeHouseName = (e, cancelToken) =>
  axiosInstance.get(`api/v1/production/dye-house?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
